<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <Card>
            <template slot="header">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="title">All Employees</h5>
                </div>
                <div class="col-sm-6 text-right">
                  <button
                    class="btn btn-primary"
                    v-if="this.$store.state.auth.user.role === 'admin'"
                    @click="openModal"
                  >Add Employee</button>
                  <button
                    style="display: none"
                    id="modal-btn"
                    data-toggle="modal"
                    data-target="#myModal"
                  ></button>
                </div>
              </div>
              <!-- <p class="category">Here is a subtitle for this table</p> -->
            </template>
            <div class="table-responsive table-full-width">
              <n-table
                class="table table-hover table-striped"
                :columns="table1.columns"
                :data="this.$store.state.auth.allUsers"
              ></n-table>
            </div>
          </Card>
        </div>
      </div>
    </div>

    <!--------------- MODAL STARTS -------------------->
    <div class="modal fade" id="myModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Add Employee</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit="addEmployee">
              <div class="form-group">
                <label for="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  placeholder="Enter employee name"
                  v-model="username"
                >
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  placeholder="Enter new password"
                  v-model="email"
                >
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    @change="handleRadioChange"
                    :checked="isAdmin"
                    value
                  >
                  <span>Admin</span>
                </label>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <button class="btn btn-primary btn-block">
                      <img src="static/img/loader.gif" v-if="isAddingEmployee" class="next-arrow">
                      <span v-else>Add</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--------------- MODAL ENDS -------------------->
  </div>
</template>
<script>
import NTable from "src/components/UIComponents/Table.vue";
import Card from "src/components/UIComponents/Cards/Card.vue";
import firebase from "../../../assets/config/firebase";
import firebaseLib from "firebase";
import "firebase/database";
import api from "../../../assets/config/api";

const tableColumns = ["Avatar", "Username", "Email", "Phone Number", "NIC"];
const tableData = [];

export default {
  components: {
    NTable,
    Card
  },
  data() {
    console.log("allusers=======================>",this.$store.state.auth.allUsers )
    return {
      table1: {
        title: "Stripped Table",
        subTitle: "Here is a subtitle for this table",
        columns: [...tableColumns],
        data: [...this.$store.state.auth.allUsers]
      },
      email: "",
      username: "",
      cnic: "",
      phone: "",
      iban: "",
      isAdmin: false,
      isLoading: false,
      isAddingEmployee: false
    };
  },
  methods: {
    openModal() {
      const modalBtn = document.querySelector("#modal-btn");
      const constants = this.$store.state.auth.constants;
      const allUsers = this.$store.state.auth.allUsers;

      const usersAllow = constants.usersAllow;

      if (usersAllow <= allUsers.length) {
        swal(
          "Upgrade Your Plan!",
          "In order to add more employees, you have to upgrade your plan!",
          "info"
        );
      } else {
        modalBtn.click();
      }
    },
    handleRadioChange(event) {
      this.isAdmin = event.target.checked;
    },
    closeModal() {
      const modalBtn = document.querySelector("#modal-btn");

      modalBtn.click();
    },
    async addEmployee(e) {
      e.preventDefault();

      const email = this.email;
      const username = this.username;
      const iban = this.iban || "";
      const phone = this.phone || "";
      const cnic = this.cnic || "";

      const role = this.isAdmin ? "admin" : "user";

      const apiBody = {
        email,
        name: username,
        cnic,
        phone,
        iban,
        role,
        companyEmail: this.$store.state.auth.company.email
      };

      try {
        this.isAddingEmployee = true;

        if (!email.trim().length) {
          throw { message: "Email is required" };
        }
        if (!username.trim().length) {
          throw { message: "name is required" };
        }

        const response = await api.createUser(apiBody);

        const data = await response.json();

        if (response.status !== 200) {
          throw data;
        }

        // this.dialog = false;

        this.isAddingEmployee = false;
        this.clearFields();
        swal("Great", "Added", "success");
      } catch (e) {
        this.isAddingEmployee = false;
        this.email = "";
        swal("Oops!", e.message, "error");
      }
    },
    clearFields() {
      this.email = "";
      this.name = "";
      this.phone = "";
      this.iban = "";
      this.cnic = "";
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/TableList.vue